module.exports = __webpack_public_path__ + "img/footer_bg.451515fd.png";